export default __webpack_public_path__ + "static/microquimica-a2e2bb4bfb0cf52498581b31e0e436bf.svg";